// vehicle images at every 30 degree angle
import vehicle330 from "../../../design-system/illustrations/dispatchVehicles/vehicle330.svg?raw";
import vehicle300 from "../../../design-system/illustrations/dispatchVehicles/vehicle300.svg?raw";
import vehicle270 from "../../../design-system/illustrations/dispatchVehicles/vehicle270.svg?raw";
import vehicle240 from "../../../design-system/illustrations/dispatchVehicles/vehicle240.svg?raw";
import vehicle210 from "../../../design-system/illustrations/dispatchVehicles/vehicle210.svg?raw";
import vehicle180 from "../../../design-system/illustrations/dispatchVehicles/vehicle180.svg?raw";
import vehicle150 from "../../../design-system/illustrations/dispatchVehicles/vehicle150.svg?raw";
import vehicle120 from "../../../design-system/illustrations/dispatchVehicles/vehicle120.svg?raw";
import vehicle90 from "../../../design-system/illustrations/dispatchVehicles/vehicle90.svg?raw";
import vehicle60 from "../../../design-system/illustrations/dispatchVehicles/vehicle60.svg?raw";
import vehicle30 from "../../../design-system/illustrations/dispatchVehicles/vehicle30.svg?raw";
import vehicle0 from "../../../design-system/illustrations/dispatchVehicles/vehicle0.svg?raw";

import { moovsBlue, successGreen, warningYellow } from "../../../design-system/colors";

const DISPATCH_STATUS_COLORS: Record<string, string> = {
  otw: successGreen,
  "on-location": warningYellow,
};

const getSvgByRotation = (rotation: number): string => {
  if (rotation >= 345 || rotation <= 15) {
    return vehicle0;
  } else if (rotation >= 15 && rotation <= 45) {
    return vehicle30;
  } else if (rotation >= 45 && rotation <= 75) {
    return vehicle60;
  } else if (rotation >= 75 && rotation <= 105) {
    return vehicle90;
  } else if (rotation >= 105 && rotation <= 135) {
    return vehicle120;
  } else if (rotation >= 135 && rotation <= 165) {
    return vehicle150;
  } else if (rotation >= 165 && rotation <= 195) {
    return vehicle180;
  } else if (rotation >= 195 && rotation <= 225) {
    return vehicle210;
  } else if (rotation >= 225 && rotation <= 255) {
    return vehicle240;
  } else if (rotation >= 255 && rotation <= 285) {
    return vehicle270;
  } else if (rotation >= 285 && rotation <= 315) {
    return vehicle300;
  } else if (rotation >= 315 && rotation <= 345) {
    return vehicle330;
  } else {
    return vehicle0;
  }
};

export const setIconPathByRotation = (
  rotation: number,
  dispatchStatus?: string
): string => {
  const rawSvg = getSvgByRotation(rotation);
  const fillColor = DISPATCH_STATUS_COLORS[dispatchStatus] || moovsBlue;

  const coloredSvg = rawSvg.replace(
    `fill="${moovsBlue}"`,
    `fill="${fillColor}"`
  );

  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(coloredSvg);
};
